<template>
    <v-card light hover>
        <v-card-media
            :src="cardInfo.image"
            height="200px"
            class="pl-2 pt-2 pr-2">
            <h6 class="white--text"></h6>
             <div
                class="fab-img"
                :style="{ 'background-image': 'url(' + cardInfo.image + ')' }"
             ></div>
        </v-card-media>
        <v-card-text>
            <v-container>
                <v-layout row wrap>
                    <v-flex xs12>
                        <p class="subheading grey--text mb-0">Nombre</p>
                        <span>{{ cardInfo.name }}</span>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
          <!-- BOTON PARA VER DETALLES DE EQUIPO LIGADO -->
          <v-tooltip top>
            <v-btn slot="activator" v-if="cardInfo.userTeam" color="green" icon @click.native="showLinkedTeam = !showLinkedTeam">
              <v-icon>{{ showLinkedTeam ? 'keyboard_arrow_down' : 'phone_iphone' }}</v-icon>
            </v-btn>
            <span>Equipo ligado</span>
          </v-tooltip>

          <!-- BOTON PARA VER ICONO DE EQUIPO LIGADO -->
          <v-tooltip top>
            <v-btn slot="activator" v-if="cardInfo.userTeamId" color="green" icon>
              <v-icon>phone_iphone</v-icon>
            </v-btn>
            <span>Equipo ligado</span>
          </v-tooltip>


          <!-- BOTON PARA COMPARTIR DYNAMICLINK DE EQUIPO -->
          <v-tooltip top>
            <v-btn slot="activator" v-if="!cardInfo.userTeam && !cardInfo.userTeamId" color="blue" icon @click.native="dynamiclinkShareDialog = true">
              <v-icon>mail_outline</v-icon>
            </v-btn>
            <span>Enviar link por correo para los jugadores de este equipo</span>
          </v-tooltip>




          <!-- MENU DE SELECCION DE GRUPO -->
          <v-menu v-if="visibleButons && enableGroupSelector" offset-y>
              <v-btn slot="activator"
               color="blue" >
                <v-icon>view_module</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile  v-for="item in groups" :key="item.id" @click="selectGroup(item.id)" >
                  <v-list-tile-title>{{item.name}} ({{item.teams.length}} equipos)</v-list-tile-title>
                </v-list-tile>

              </v-list>
          </v-menu>




            <v-spacer></v-spacer>


            <v-tooltip top>
              <v-btn slot="activator"
              small
               :color="actionBtn.color" icon
               @click="submit"
               v-if="visibleButons"
               >
                <v-icon>{{  actionBtn.icon  }}</v-icon>
              </v-btn>
              <span>{{ actionBtn.msg }}</span>
            </v-tooltip>






        </v-card-actions>
        <!-- INFO DE EQUIPO LIGADO -->
        <v-slide-y-transition>
          <v-card-text class="gray" v-show="showLinkedTeam && cardInfo.userTeam != null">
            <v-container v-if="cardInfo.userTeam">
                <p>Equipo ligado en la app:</p>
                <v-layout row wrap>
                    <v-flex xs12 layout justify-center>
                      <v-avatar
                        :tile="false"
                        size="100px"
                        class="grey lighten-4"
                      >
                        <img :src="cardInfo.userTeam.image.thumb || cardInfo.userTeam.image.letter" alt="avatar">
                      </v-avatar>

                    </v-flex>
                    <v-flex mb-0 pb-0 xs12 layout justify-center>
                      <h6>{{cardInfo.userTeam.name}}</h6>
                    </v-flex>
                    <v-flex mt-0 pt-0 xs12 layout justify-center>
                      {{cardInfo.userTeam.place.place_name}}
                      </br>
                      {{cardInfo.userTeam.place.address}}
                    </v-flex>
                    <v-flex mb-0 pb-0 mt-0 pt-0 xs12 layout justify-center>
                      <v-btn flat
                          color="green"
                          class="black--text"
                          @click.native="showPlayers()"
                          >Jugadores {{ '(' + cardInfo.userTeam.players.length + ')' }}</v-btn>

                      <!--  <v-spacer></v-spacer>-->

                        <v-btn flat
                            :color="actionBtn.color"
                            class="black--text"
                            @click="unlinkTeam()"
                            :disabled="tournamentFinalized || disable">Desligar</v-btn>

                    </v-flex>
                </v-layout>
            </v-container>
          </v-card-text>

        </v-slide-y-transition>
        <!-- FIN INFO DE EQUIPO LIGADO -->

        <!-- DIALOGO DE LISTA DE JUGADORES -->
        <v-dialog max-width="2000px" v-model="playersDialog" persistent>
          <v-card light>
            <v-card-title class="headline">
              Jugadores
            </v-card-title>
            <v-card-text>
              <v-data-table
                light
                v-if="cardInfo.userTeam"
                v-bind:headers="playersHeaders"
                :items="cardInfo.userTeam.players"
                hide-actions
                class="elevation-1"
              >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.user ?  props.item.user.email : ""}}</td>
                <td>{{ props.item.status_in_tournament}}</td>
                <td>
                  <v-btn flat
                    color="green darken-1"
                      @click="selectPlayer(props.item)"
                      small
                      >Ficha completa</v-btn>
                </td>
              </template>
            </v-data-table>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" flat @click.native="downloadPdf()">Lista de jugadores (Aceptados)</v-btn>
              <v-btn color="red darken-1" flat @click.native="playersDialog = false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- FIN DIALOGO DE LISTA DE JUGADORES -->

        <!-- DIALOGO ENVIAR EMAIL CON DYNAMICLINK DE LIGADO DE EQUIPO -->
        <simple-text-input
          @confirm="confirmDynamiclinkShareDialog"
          :dialog="dynamiclinkShareDialog"
           labelText="Correo electronico para compartir equipo"
           :default="''"
           positiveText="Enviar link">
         </simple-text-input>
        <!-- FIN DIALOGO ENVIAR EMAIL CON DYNAMICLINK DE LIGADO DE EQUIPO -->

        <!-- DETALLE DE UN JUGADOR LIGADO -->


          <!--
          <player-official-info
            @close="selectedPlayer = null"
            :player="selectedPlayer"
             />
           -->


        <!-- FIN DETALLE DE UN JUGADOR LIGADO -->
    </v-card>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import PlayerOfficialInfo from './PlayerOfficialInfo'
import SimpleTextInput from '@/components/helpers/modals/SimpleTextInput'

export default {
    name: 'TeamCard',
    components: {
      PlayerOfficialInfo,
      SimpleTextInput
    },
    props: {
        actionBtn: {
            default: () => {
                return { color: 'green', msg: 'Agregar equipo a este torneo', icon:'add' }
            }
        },
        cardInfo: { required: true },
        add: { required: true },
        tournamentFinalized: { default: false },
        disable:{default: false},
        enableGroupSelector:{default: false},
        group:{default:null}
    },
    data() {
        return {
          dynamiclinkShareDialog:false,
          selectedPlayer:null,
          showLinkedTeam:false,
          playersDialog:false,
          playersHeaders: [
            { text: 'Nombre', value: 'name', align: 'left', sortable: false },
            { text: 'Correo', value: 'email', align: 'left', sortable: false  },
            { text: 'Status', value: 'status', align: 'left', sortable: false  },
            { text: 'Acciones', value: 'actions', align: 'left', sortable: false  }
          ]
        }
    },
    created() {
      //do something after creating vue instance
      console.log("CREATED",this.cardInfo)

    },
    watch:{
      cardInfo(info){
        console.log("WATCH",info)
      }
    },
    computed:{
      ...mapGetters([
        "currentTournament",
        "currentTournamentGroups"
      ]),
      visibleButons(){
        if(this.tournamentFinalized  || this.disable){
          return false
        }
        return true
      },
      groups(){
        if(!this.group){
          return this.currentTournamentGroups
        }
        var result = []
        for(var i in this.currentTournamentGroups){
          if(this.currentTournamentGroups[i].id != this.group.id){
            result.push(this.currentTournamentGroups[i])
          }
        }
        return result
      }
    },
    methods: {
      ...mapActions([
        "downloadAcceptPlayersPdf",
        "editTeamGroup",
        "sendTeamLink"
      ]),
        submit() {
            this.$emit('add', {
                    id: this.cardInfo.id,
                    addTeamMode: this.add,
                })
        },
        unlinkTeam(){
          this.$emit('unlink', {
                  id: this.cardInfo.id
              })
        },
        showPlayers(){
          console.log("showPlayersA")
          this.$emit('showplayers', {
                  id: this.cardInfo.id,
                  name: this.cardInfo.name
              })
        },
        selectPlayer(player){
          this.playerOfficialInfoVisible = true
          this.selectedPlayer = player
        },
        downloadPdf(){
          let data = {
            tournamentId:this.currentTournament.id,
            teamId:this.cardInfo.userTeam.id
          }
          this.downloadAcceptPlayersPdf(data)
        },
        selectGroup(groupId){
          let data = {
            tournamentId: this.currentTournament.id,
            groupId: groupId,
            teamId: this.cardInfo.id
          }
          this.editTeamGroup(data)
        },
        confirmDynamiclinkShareDialog(response,value){
          if(response == false){this.dynamiclinkShareDialog = false}
          if(response == true && value && value.length>1){
            this.dynamiclinkShareDialog = false
            this.sendTeamLink({
              teamid:this.cardInfo.id,
              email:value
            })

          }
        }
    }
}
</script>

<style lang="css" scoped>
    .fab-img {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        width: 60px;
        height: 60px;
        position: absolute;
        border-radius: 50%;
        bottom: -30px;
        box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px rgba(0,0,0,.14), 0 1px 18px rgba(0,0,0,.12);
        right: 0;
    }
    .card__media {
        overflow: visible !important;
    }
    .gray{
      background: #e8e8e8;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/teams/TeamCard.vue